export default {
	ERROR: 1,
	NO_METAMASK: 2,
	AUTH_NO_NFTS: 3,
	AUTH_SIGN_OUT: 4,
};
